<template>
    <Dialog
        :show='show'
        okText='Dupliquer'
        cancelText='Annuler'
        title='Dupliquer une exploitation'
        @cancel="$emit('cancel')"
        @validate="onValidate"
        class="large"
    >
      <span class='message'>
        <div class='wrap'>
          <v-field-text v-model='text' label="Libellé de la nouvelle exploitation" v-validate='"required"' name="libellé" />
        </div>
        <template v-if="simulations.length">
            <div class='wrap'>
                <label>Simulation à dupliquer</label>
            </div>
            <div class='wrap'>
                <div v-for="simulation in simulations" :key="simulation.id_simulation">
                    <input type="checkbox" v-model="checkedId" :value="simulation.id_simulation">
                    <span>{{ simulation.nom }} ( {{ 'îlot' | pluralize(simulation.nbilot) }}, {{ 'scénario' | pluralize(simulation.nbscenario) }} )</span>
                </div>
            </div>
        </template>
        <div v-else>
            <span v-if="loading">Chargement...</span>
            <span v-else>Aucune simulation à dupliquer</span>
        </div>
      </span>
    </Dialog>
  </template>

<script>
import Dialog from '@/components/Dialog'
import { getSimulations } from '@/api/client-api'

export default {
  name: 'PromptSimulation',
  inject: ['$validator'],

  components: {
    Dialog
  },

  data () {
    return {
      text: null,
      loading: false,
      simulations: () => [],
      checkedId: []
    }
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    exploitation: {
      type: Object,
      default: null
    }
  },

  watch: {
    show: function (newValue) {
      if (newValue === true) {
        this.initData()
      }
    }
  },

  methods: {
    initData () {
      this.loading = true
      this.text = 'Copie de ' + this.exploitation.actualName
      getSimulations(this.exploitation.idExploitation)
        .then(simulations => {
          this.simulations = simulations
          this.checkedId = simulations.map(s => s.id_simulation)
          this.loading = false
        })
    },
    onValidate () {
      this.$validator.validateScopes().then((result) => {
        if (result) {
          this.$emit('validate', {
            idExploitation: this.exploitation.idExploitation,
            nom: this.text,
            idSimulations: this.checkedId
          })
        }
      })
    }
  }
}
</script>
